import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { List } from 'semantic-ui-react';

// Global Selectors
import { makeSelectHarvestEventForecastedQuantity } from 'services/harvestEvents/selectors';

// Local Selectors
import { selectScheduledQuantity } from '../../selectors';

interface Props {
    forecastedQuantity?: number;
    scheduledQuantity: number;
}

class ScheduledAndForecastedTotals extends React.PureComponent<Props> {
    static defaultProps = {
        forecastedQuantity: 0
    };

    render() {
        const { forecastedQuantity, scheduledQuantity } = this.props;

        return (
            <List verticalAlign="middle">
                <List.Item>
                    <List.Content floated="right" color="grey">
                        {scheduledQuantity}
                    </List.Content>
                    <List.Content>Scheduled</List.Content>
                </List.Item>
                {!!forecastedQuantity && (
                    <List.Item>
                        <List.Content floated="right" color="grey">
                            {forecastedQuantity}
                        </List.Content>
                        <List.Content>Forecasted</List.Content>
                    </List.Item>
                )}
            </List>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    forecastedQuantity: makeSelectHarvestEventForecastedQuantity(),
    scheduledQuantity: selectScheduledQuantity
});

export default connect(mapStateToProps)(ScheduledAndForecastedTotals);
